import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Textarea, TextareaControlled } from "./../../";
import TextareaExample from "./../../sample/_textarea.example.js";
import Alertstripe from "nav-frontend-alertstriper";
import Lenke from "nav-frontend-lenker";
export const _frontmatter = {
  "ingress": "Textarea tillater brukeren å legge inn fritekst som kan gå over flere linjer."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#uten-teller"
          }}>{`Uten teller`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#disabled"
          }}>{`Disabled`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#feilmelding"
          }}>{`Feilmelding`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#innhold-mellom-label-og-skjemafelt"
          }}>{`Innhold mellom label og skjemafelt`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#manuell-håndtering-av-state"
          }}>{`Manuell håndtering av state`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <TextareaControlled label="Textarea-label" mdxType="TextareaControlled" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<TextareaControlled label="Textarea-label" />
`}</code></pre>
    <h2 {...{
      "id": "uten-teller"
    }}>{`Uten teller`}</h2>
    <Example mdxType="Example">
  <TextareaControlled label="Textarea-label" maxLength={0} mdxType="TextareaControlled" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<TextareaControlled label="Textarea-label" maxLength={0} />
`}</code></pre>
    <h2 {...{
      "id": "disabled"
    }}>{`Disabled`}</h2>
    <Alertstripe type="advarsel" mdxType="Alertstripe">
  Merk at disabled bør unngås, og at bruken heller bør løses på andre måter, da
  fks kombinert med tydelige feilmeldinger hvis handlingen av en eller annen
  grunn ikke er tillatt. Ler mer om dette på{" "}
  <Lenke href="/accessibility/disabled" mdxType="Lenke">siden vår om `disabled`</Lenke>.
    </Alertstripe>
    <Example mdxType="Example">
  <TextareaControlled label="Textarea-label" disabled mdxType="TextareaControlled" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<TextareaControlled label="Textarea-label" disabled />
`}</code></pre>
    <h2 {...{
      "id": "feilmelding"
    }}>{`Feilmelding`}</h2>
    <Example mdxType="Example">
  <TextareaControlled label="Textarea-label" feil="Her er det noe feil." mdxType="TextareaControlled" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<TextareaControlled label="Textarea-label" feil="Her er det noe feil." />
`}</code></pre>
    <h2 {...{
      "id": "innhold-mellom-label-og-skjemafelt"
    }}>{`Innhold mellom label og skjemafelt`}</h2>
    <p>{`Bruk `}<inlineCode parentName="p">{`description`}</inlineCode>{`-propen for å legge inn egendefinert HTML-innhold mellom labelen og skjemafeltet.`}</p>
    <Example mdxType="Example">
  <TextareaControlled label="Textarea-label" description="Beskriv kort din situasjon" mdxType="TextareaControlled" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<TextareaControlled
  label="Textarea-label"
  description="Beskriv kort din situasjon"
/>
`}</code></pre>
    <h2 {...{
      "id": "manuell-håndtering-av-state"
    }}>{`Manuell håndtering av state`}</h2>
    <p>{`Hvis du ønsker å håndtere state manuelt, kan du bruke `}<inlineCode parentName="p">{`Textarea`}</inlineCode>{` i stedet for `}<inlineCode parentName="p">{`TextareaControlled`}</inlineCode></p>
    <Example mdxType="Example">
  <TextareaExample mdxType="TextareaExample" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Textarea
  value={this.state.value}
  onChange={(e) => this.setState({ value: e.target.value })}
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      